/* eslint-disable import/no-named-as-default */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-console */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useRef } from 'react'
import styled, { css } from 'styled-components'
import { useStaticQuery, graphql } from "gatsby"
import { v4 } from 'uuid'

// Phonenumber
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import en from 'react-phone-number-input/locale/en'
import nl from 'services/nl.json'

// Components
import Content from 'components/shared/Content'
import Loading from 'components/shared/Loading'

// Elements
import ButtonDefault from 'components/elements/ButtonDefault'
import { LabelCSS, InputCSS, TextareaCSS } from 'components/elements/Form'

// Imags
import Upload from 'img/icon/upload.inline.svg'

// Third Party
import Select from 'react-select'
import { getLanguage } from '../services/language'

const StyledForm = styled.form`
  position: relative;
`

const ConfirmationMessage = styled(Content)`
  font-size: ${props => props.theme.font.size.l};
  text-align: center;

  ${props => props.vacature && css`
    color: ${props.theme.color.light};
  `}
`

const Label = styled.label`
  ${LabelCSS};
`

const Input = styled.input`
  ${InputCSS};
`

const Textarea = styled.textarea`
  ${TextareaCSS};
  height: 200px;
`

const GravityForm = ({ vacature, brochure, className, id, defaultValues = {} }) => {
  const { allGfForm: { edges: gravityData } } = useStaticQuery(graphql`
    query {
      allGfForm {
        edges {
          node {
            formId
            slug
            apiURL
            descriptionPlacement
            formFields {
              id
              label
              labelPlacement
              description
              descriptionPlacement
              type
              choices
              content
              errorMessage
              inputMaskValue
              isRequired
              visibility
              cssClass
              placeholder
              size
              defaultValue
              maxLength
            }
            button {
              text
            }
            confirmations {
              message
              type
              url
            }
          }
        }
      }
    }
  `)

  const { node: gfForm } = gravityData.filter(({ node }) => node.formId === id)[0]

  const [fields, setFields] = useState(defaultValues)
  const [form, setForm] = useState(gfForm)
  const [status, setStatus] = useState('')
  const [message, setMessage] = useState('')

  useEffect(() => {
    const tempForm = form

    // add submit button as a field
    if (tempForm.formFields.filter((item) => item.type === "submit").length === 0) {
      tempForm.formFields = [
        ...tempForm.formFields,
        {
          formId: v4(),
          type: "submit",
          text: tempForm.button.text
        }
      ]
    }

    setForm({
      ...form,
      ...tempForm
    })
  }, [])

  async function handleOnSubmit(event) {
    event.preventDefault()

    if (status === 'processing') {
      return
    }

    setStatus('processing')

    try {
      const formData = new FormData()

      if (defaultValues) {
        for (const [key, value] of Object.entries(defaultValues)) {
          formData.append(key, value);
        }
      }

      for (const [key, value] of Object.entries(fields)) {
        formData.append(key, value)
      }

      const request = await fetch(`${form.apiURL}/submissions`, {
        method: 'POST',
        body: formData
      })

      const response = await request.json()
      if (response.is_valid === true) {
        setStatus('done')

        const confirmation = form.confirmations[0];
        if (confirmation.type === 'redirect') {
          setMessage(getLanguage() === 'nl_NL' ? 'U wordt doorgestuurd..' : 'Redirecting..')

          if (form.formId === 7 || form.formId === 8) {
            let paymentUrl = `${confirmation.url}${fields.input_4}`;
            if (getLanguage() !== 'en_US') {
              paymentUrl = `${paymentUrl}?_locale=en`
            }

            window.open(paymentUrl, '_self')
          } else {
            window.open(confirmation.url)
          }
        } else {
          setMessage(response.confirmation_message)
        }
      } else {
        setStatus('error')
      }
    } catch (error) {
      setStatus('error')
    }
  }

  function handleFieldChange(event) {
    // eslint-disable-next-line prefer-destructuring
    let { value } = event.target || event.value

    if (event.target) {
      if (event.target.type === "checkbox") {
        value = event.target.checked ? event.target.value : ""
      }

      setFields({
        ...fields,
        [event.target.name]: value
      })
    } else {
      setFields({
        ...fields,
        [event.name]: event.value
      })
    }
  }

  if (status === "done") {
    return <ConfirmationMessage vacature={vacature} content={message} />
  }

  if (form.formFields) {
    return (
      <StyledForm id={`form_${gfForm.formId}`} className={className} method="post" onSubmit={handleOnSubmit}>
        {status === "processing" && (
          <Loading />
        )}
        {form.formFields && form.formFields.map((field, key) => {
          if (field.visibility === 'hidden') {
            return null
          }

          if (Array.isArray(field)) {
            return (
              <div key={key}>
                {field.map((item, index) => (
                  <FormField vacature={vacature} brochure={brochure} key={index} field={item} fields={fields} onChange={handleFieldChange} />
                ))}
              </div>
            )
          }

          return (
            <div key={key}>
              <FormField vacature={vacature} brochure={brochure} field={field} fields={fields} onChange={handleFieldChange} />
            </div>
          )
        })}
      </StyledForm>
    )
  }

  console.error("No gravity forms found with id", id)
  return false;
}

const StyledTextField = styled.div`
  ${Label} {
    ${props => props.vacature && css`
      color: ${props.theme.color.light};
    `}
  }
`

const TextField = ({ vacature, value, onChange, field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass } }) => (
  <StyledTextField vacature={vacature} className="form-group">
    {labelPlacement !== "hidden_label" && (
      <Label htmlFor={`input_${id}`}>
        {label}
        {isRequired && (<span>*</span>)}
      </Label>
    )}
    <Input
      value={value}
      onChange={onChange}
      type="text"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </StyledTextField>
)

const NumberField = ({ vacature, value, onChange, field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass } }) => (
  <StyledTextField vacature={vacature} className="form-group">
    {labelPlacement !== "hidden_label" && (
      <Label htmlFor={`input_${id}`}>
        {label}
        {isRequired && (<span>*</span>)}
      </Label>
    )}

    <Input
      value={value}
      onChange={onChange}
      type="number"
      step="any"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </StyledTextField>
)

const StyledEmailField = styled.div`
  ${Label} {
    ${props => props.vacature && css`
      color: ${props.theme.color.light};
    `}
  }
`

const EmailField = ({ vacature, value, onChange, field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass } }) => (
  <StyledEmailField vacature={vacature} className="form-group">
    {labelPlacement !== "hidden_label" && (
      <Label htmlFor={`input_${id}`}>
        {label}
        {isRequired && (<span>*</span>)}
      </Label>
    )}
    <Input
      value={value}
      onChange={onChange}
      type="email"
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </StyledEmailField>
)

const StyledPhoneField = styled.div`
  ${Label} {
    ${props => props.vacature && css`
      color: ${props.theme.color.light};
    `}
  }

  & .PhoneInput {
    ${InputCSS};
    overflow: hidden;

    ${props => props.brochure && css`
      background-color: ${props.theme.color.light};
    `}

    & input {
      border: none; 
    }
  }
`

const PhoneField = ({ vacature, brochure, value, onChange, field: { id, type, label, labelPlacement, placeholder, isRequired } }) => (
  <StyledPhoneField vacature={vacature} brochure={brochure} className="form-group">
    {labelPlacement !== "hidden_label" && (
      <Label htmlFor={`input_${id}`}>
        {label}
        {isRequired && (<span>*</span>)}
      </Label>
    )}
    <PhoneInput
      labels={getLanguage() === 'nl_NL' ? nl : en}
      id={`input_${id}`}
      placeholder={placeholder}
      value={value}
      name={`input_${id}`}
      required={isRequired}
      onChange={number => {
        onChange({ target: { value: number, type, name: `input_${id}` } })
      }}
    />
  </StyledPhoneField>
)

const TextAreaField = ({ value, onChange, field: { id, type, label, labelPlacement, placeholder, isRequired, cssClass } }) => (
  <div className="form-group">
    {labelPlacement !== "hidden_label" && (
      <Label htmlFor={`input_${id}`}>
        {label}
        {isRequired && (<span>*</span>)}
      </Label>
    )}
    <Textarea
      value={value}
      onChange={onChange}
      id={`input_${id}`}
      className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
      name={`input_${id}`}
      required={isRequired}
      placeholder={placeholder}
    />
  </div>
)

const CheckboxField = ({ value, onChange, field: { id, type, cssClass, choices } }) => {
  const list = JSON.parse(choices);

  return (
    <div className="form-group">
      {list.map((checkbox, key) => (
        <div key={key} className="form-group__checkboxes">
          <input
            checked={value}
            onChange={onChange}
            type="checkbox"
            id={`input_${id}_${key + 1}`}
            className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
            name={`input_${id}_${key + 1}`}
            value={checkbox.value}
          />
          <label htmlFor={`input_${id}_${key + 1}`} className="checkbox-content">{checkbox.text}</label>
        </div>
      ))}
    </div>
  )
}

const StyledSelect = styled.div`

`

// Select or Dropdown
const SelectField = ({ field, onChange, value }) => {

  // Populate a options array
  const options = []

  JSON.parse(field.choices).forEach(choice => {
    options.push({
      value: choice.value,
      label: choice.text,
      type: 'select',
      name: `input_${field.id}`
    })
  })

  // Custom Select component
  const MySelect = props => (
    <Select
      {...props}
      onChange={props.onChange}
      options={props.options}
      placeholder={props.placeholder}
    />
  )

  return (
    <StyledSelect>
      <MySelect
        options={options}
        onChange={onChange}
        value={options.filter(option => option.value === value)}
        placeholder={field.label}
        classNamePrefix="react-select"
      />
    </StyledSelect>
  )
}

const Submit = styled.button`
  color: ${props => props.theme.color.text.light};

  &:hover {
    text-decoration: underline;
  }
`

const SubmitButton = ({ field }) => (
  <div className="text-right mt-3">
    <ButtonDefault isCustom type="next">
      <Submit type="submit">
        {field.text}
      </Submit>
    </ButtonDefault>
  </div>
)

const StyledFileField = styled.div`
  ${Label} {
    ${props => props.vacature && css`
      color: ${props.theme.color.light};
    `}
  }

  .show-file {
    color: #FFFFFF !important;
  }

  button {
    height: 45px;
    width: 100%;
    background-color: ${props => props.theme.color.light};
    border-radius: 15px;
    color: ${props => props.theme.color.text.contrast};
    text-overflow: ellipsis;
    margin-bottom: 3rem;
  }

  input {
    display: none;
  }
`

const FileField = ({ vacature, value, onChange, field: { id, type, label, description, allowedExtensions, cssClass, placeholder } }) => {

  const inputRef = useRef(null)

  function handleChange(file) {
    onChange({
      target: {
        name: `input_${id}`,
        value: file
      }
    })
  }

  function handleFileUpload(e) {
    const { target: { files } } = e;

    for (let i = 0; i < files.length; i += 1) {
      handleChange(files[i])
    }
  }

  function handleFileDrop(e) {
    e.preventDefault();

    if (e.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.items.length; i += 1) {
        // If dropped items aren't files, reject them
        if (e.dataTransfer.items[i].kind === 'file') {
          handleChange(e.dataTransfer.items[i].getAsFile());
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.files.length; i += 1) {
        handleChange(e.dataTransfer.files[i]);
      }
    }
  }

  return (
    <StyledFileField vacature={vacature} className="form-upload" onDrop={handleFileDrop} onDragOver={e => e.preventDefault()}>
      <Label htmlFor={`input_${id}`}>
        {label}
      </Label>
      <button
        type="button"
        onClick={() => { inputRef.current.click() }}
      >
        {value ? value.name : description}
        <Upload className="ml-2" />
      </button>
      <input
        ref={inputRef}
        type="file"
        onChange={handleFileUpload}
        id={`input_${id}`}
        className={`${type} ${cssClass !== undefined ? cssClass : ""}`}
        name={`input_${id}`}
        placeholder={placeholder}
        accept={allowedExtensions}
      />
    </StyledFileField>
  )
}

export const FormField = ({ vacature, brochure, field, fields, onChange }) => (
  <>
    {field.type === "text" && <TextField vacature={vacature} onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "number" && <NumberField vacature={vacature} onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "email" && <EmailField vacature={vacature} onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "phone" && <PhoneField vacature={vacature} brochure={brochure} onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "textarea" && <TextAreaField vacature={vacature} onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "checkbox" && <CheckboxField vacature={vacature} onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "select" && <SelectField vacature={vacature} onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "fileupload" && <FileField vacature={vacature} onChange={onChange} value={fields[`input_${field.id}`]} field={field} />}
    {field.type === "submit" && <SubmitButton vacature={vacature} field={field} />}
  </>
)

export default GravityForm


